import { render, staticRenderFns } from "./BoxesTable.vue?vue&type=template&id=12883194&scoped=true&"
import script from "./BoxesTable.vue?vue&type=script&lang=js&"
export * from "./BoxesTable.vue?vue&type=script&lang=js&"
import style0 from "./BoxesTable.vue?vue&type=style&index=0&id=12883194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12883194",
  null
  
)

export default component.exports